import { PrimeReactPTOptions } from "primereact/api";
import { InputNumberPassThroughMethodOptions } from "primereact/inputnumber";
import { InputTextPassThroughMethodOptions } from "primereact/inputtext";
import { classNames } from "primereact/utils";

export const inputnumber: PrimeReactPTOptions["inputnumber"] = {
  input: {
    root: ({
      parent,
      props,
    }: InputNumberPassThroughMethodOptions & { parent: InputTextPassThroughMethodOptions }) => {
      return {
        className: classNames(
          "border border-urbe-border",
          "outline-rdc-primary outline-offset-0 rounded text-urbe-text text-sm  bg-white",
          {
            "bg-urbe-primaryLight": parent?.props.variant === "filled",
            "border-urbe-errorValidation": props?.invalid,
            "bg-urbe-grayLight select-none pointer-events-none cursor-default": props.disabled,
          },
        ),
      };
    },
  },
};
